// Finds `needle` in `text` ignoring all whitespace, since PDF text often breaks lines mid-sentence
// (or mid-word). Returns [start, end] indexes into the original text, or null.
function findLoose(text, needle) {
  const target = needle.replace(/\s+/g, "");
  if (!target) return null;
  const positions = [];
  let compact = "";
  for (let i = 0; i < text.length; i += 1) {
    if (!/\s/.test(text[i])) {
      positions.push(i);
      compact += text[i];
    }
  }
  const at = compact.indexOf(target);
  if (at === -1) return null;
  return [positions[at], positions[at + target.length - 1] + 1];
}

// Applies the accepted suggestions to the resume text. Edits that can't be located are listed separately.
export function applyEdits(baseText, suggestions) {
  let text = baseText;
  const unmatched = [];
  suggestions
    .filter((s) => s.accepted)
    .forEach((s) => {
      const range = findLoose(text, s.before);
      if (!range) {
        unmatched.push(s);
        return;
      }
      text = text.slice(0, range[0]) + s.after + text.slice(range[1]);
    });
  return { text, unmatched };
}
